export default __webpack_public_path__ + "static/media/botox.0ce5e05a.pdf";